import React, { useEffect, useState } from 'react'
import { useAppData } from '../../../../../../context/AppDataContext'

import ConfirmDelete from '../../../../../../components/ConfirmDelete';
import { useAlert } from '../../../../../../context/AlertContext';

import proposalItemService from '../proposalItemServices';
import ProposalItemFrom from './ProposalItemFrom';
import ProposalItemEditForm from './ProposalItemEditForm';


function ProposalItemList({ proposalDetails, productList, isPrinting,tableRef }) {
    const { getMasterLabel } = useAppData();
    const { AppAlert } = useAlert();
    const [itemList, setItemList] = useState([]);
    const [total,setTotal] = useState(0);

    const getItemList = () => {
        proposalItemService.getByProposalId(proposalDetails.id).then(res => {
            setItemList(res.data);
        }).catch(error => {
            console.error("Error fetching items", error);
        });
    }

    useEffect(() => {
        getItemList();
    }, [proposalDetails])
    
    const deleteItem = (id) => {
        proposalItemService.remove(id).then(res => {
            AppAlert("Item Removed from proposal");
            getItemList();
        }).catch(error => {
            AppAlert(error.msg || "Error removing item", "error")
        })
    }

    const calculateTotal = () => {
        if (itemList) {
            let _total = 0;
            itemList.forEach(_item => {   
                _total += Number(_item.amount || 0);
            });
            const roundedTotal = Math.round(_total);
            setTotal(roundedTotal);
        }
    }
    
    useEffect(() => {
        calculateTotal();
    }, [itemList]);

    
    return (
        itemList && <>
            <table ref={tableRef} className='table border-dark table-sm table-striped table-bordered mb-0' style={{ fontSize: 12 }}>
                <thead className='table-dark'>
                    <tr>
                        <th>#</th>
                        <th>Item Description</th>
                        <th>HSN</th>
                        <th>Qty</th>
                        <th>UOM</th>
                        <th>Rate</th>
                        <th>Amount</th>
                    </tr>
                </thead>
                
                <tbody>
                    {itemList.map((item, i) => (
                        <tr key={`primary-${i}`} className="hover-container">
                            <td>{i + 1}</td>
                            <td>
                                <div className='d-flex justify-content-between'>
                                    <div>
                                        <div className='fw-bold'>{item.title}</div>
                                        <div className='ms-2'>{item.details}</div>
                                    </div>
                                    {proposalDetails.status === 1 && (
                                        <div>
                                            <ConfirmDelete id={item.id} confirm={deleteItem}>
                                                Remove {item.title} from proposal?
                                            </ConfirmDelete>
                                            <ProposalItemEditForm proposalItem={item} callBack={getItemList}  />
                                        </div>
                                    )}
                                </div>
                            </td>
                            <td>{item.hsn}</td>
                            <td>{item.qty}</td>
                            <td>{getMasterLabel("product-uom", item.uom)}</td>
                            <td>{item.price}</td>
                            <td>{item.amount }</td>
                        </tr>
                    ))}
                    
                    {!isPrinting && proposalDetails.status === 1 && (
                        <tr>
                            <td colSpan={8} className="p-0">
                                <ProposalItemFrom
                                    proposalDetails={proposalDetails} 
                                    callBack={getItemList} 
                                    productList={productList} 
                                />
                            </td>
                        </tr>
                    )}
                    <tr className="table-warning-subtle text-dark">
                        <td colSpan={6} className="text-end fw-bold fst-italic">Total (Excl. Tax):</td>
                        <td className="fw-bold">{total}</td>
                    </tr>
                </tbody>
            </table>
        </>
    )
}

export default ProposalItemList;